import * as types from '../constants/favorites';

let initialState = {
  total: null,
  page: 1,
  per_page: 10,
  isLoading: false,

  products: [],
  filters: [],
  sort: {
    type: 'price',
    direction: 'desc',
  },
  selectedFilters: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.RESET_FILTERS:
      return {
        ...state,
        selectedFilters: [],
        filters: {},
        total: null,
      };
    case types.SET_FILTER:
      return {
        ...state,
        selectedFilters: payload,
      };
    case types.FETCH_PRODUCTS_BEGIN:
      return {
        ...state,
        isLoading: true,
      };
    case types.FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: payload.products,
        filters: payload.filters,
        total: payload.total,
        isLoading: false,
      };
    case types.FETCH_PRODUCTS_ERROR:
      return {
        ...state,
        products: [],
        filters: [],
        total: 0,
        isLoading: false,
      };
    default:
      return state;
  }
};
